export default {
  BUTTONS: {
    YES: 'Ja',
    CANCEL: 'Abbrechen',
  },
};
